import { render } from "./selectTrainCourse.vue?vue&type=template&id=8dfd5e18"
import script from "./selectTrainCourse.vue?vue&type=script&lang=js"
export * from "./selectTrainCourse.vue?vue&type=script&lang=js"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__